import initialState from "../models/forms";

export const types = {
  SUBMIT_REQUESTED: "SUBMIT_REQUESTED",
  SUBMIT_SUCCEDDED: "SUBMIT_SUCCEDDED",
  SUBMIT_FAILED: "SUBMIT_FAILED",
  GET_FORM: "GET_FORM",
  GET_FORM_SUCCEDDED: "GET_FORM_SUCCEDDED",
  GET_FORM_FAILED: "GET_FORM_FAILED",
  GET_FORMS: "GET_FORMS",
  GET_FORMS_SUCCEDDED: "GET_FORMS_SUCCEDDED",
  GET_FORMS_FAILED: "GET_FORMS_FAILED",
  GET_DOC_FORMS: "GET_DOC_FORMS",
  GET_DOC_FORMS_SUCCEDDED: "GET_DOC_FORMS_SUCCEDDED"
};

export const actions = {
  getForms: query => {
    return { type: types.GET_FORMS, value: query };
  },
  getForm: () => {
    return { type: types.GET_FORM };
  },
  submit: payload => {
    return { type: types.SUBMIT_REQUESTED, value: payload };
  },
  getDocForms: () => {
    return { type: types.GET_DOC_FORMS };
  },
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_FORMS_SUCCEDDED:
      return {
        ...state,
        formOptions: action.value,
        formValue: state.formValue
      }

    case types.GET_FORM_SUCCEDDED:
      return {
        ...state,
        formValue: action.value,
        formOptions: state.formOptions
      };

    case types.GET_FORMS_FAILED:
      return {
        ...state,
        errors: action.value,
      };

    case types.SUBMIT_FAILED:
      return {
        ...state,
        errors: action.value,
      };

    case types.SUBMIT_SUCCEDDED:
      return {
        ...state,
        formOptions: state.formOptions,
        formValue: state.formValue,
        form: action.value,
      };

    case types.GET_DOC_FORMS_SUCCEDDED:
      return {
        ...state,
        formOptions: action.value,
        formValue: state.formValue,
      }

    default:
      return state;
  }
};

export default reducer;
